import { createNode, ZonedDateTimeDataType, PlainDateTimeDataType } from '@glueapp/graph-types';
import { toZonedDateTime, fromPlainDateTime } from '../../utils/temporal';

export const ZonedDateTimeToDateTime = createNode({
    id: 'ZonedDateTime to DateTime',
    name: 'ZonedDateTime to DateTime',
    description: 'Removes the timezone from a ZonedDateTime, keeping the wall clock time',
    aiDescription:
        'Takes a ZonedDateTime on the "ZonedDateTime" port and outputs a DateTime on the "DateTime" port with the timezone removed, preserving the wall clock date and time.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    outPorts: {
        DateTime: PlainDateTimeDataType,
    },
    execute: function (input) {
        const zdt = toZonedDateTime(input.inPorts.ZonedDateTime);
        return { output: { DateTime: fromPlainDateTime(zdt.toPlainDateTime()) } };
    },
});
